const country = [
  {
    continent: "ASIA",
    regions: [
      {
        name: "ASEAN",
        countries: [
          "BRUNEI",
          "CAMBODIA",
          "INDONESIA",
          "LAOS",
          "MALAYSIA",
          "MYANMAR",
          "SINGAPORE",
          "THAILAND",
          "VIETNAM",
        ],
      },
      {
        name: "EAST ASIA",
        countries: [
          "CHINA",
          "HONGKONG",
          "JAPAN",
          "NORTH KOREA",
          "SOUTH KOREA",
          "TAIWAN",
        ],
      },
      {
        name: "SOUTH ASIA",
        countries: [
          "AFGHANISTAN",
          "BANGLADESH",
          "INDIA",
          "IRAN",
          "IRAQ",
          "LEBANON",
          "NEPAL",
          "PAKISTAN",
          "SRI LANKA",
          "TURKEY",
        ],
      },
      {
        name: "MIDDLE EAST",
        countries: [
          "BAHRAIN",
          "EGYPT",
          "ISRAEL",
          "JORDAN",
          "KUWAIT",
          "OMAN",
          "QATAR",
          "SAUDI ARABIA",
          "UNITED ARAB EMIRATES",
        ],
      },
    ],
  },
  {
    continent: "AMERICA",
    regions: [
      {
        name: "NORTH AMERICA",
        countries: ["BAHAMAS", "CANADA", "MEXICO", "USA"],
      },
      {
        name: "SOUTH AMERICA",
        countries: [
          "ARGENTINA",
          "BRAZIL",
          "CHILE",
          "COLOMBIA",
          "COSTA RICA",
          "ECUADOR",
          "PANAMA",
          "PERU",
          "VENEZUELA",
        ],
      },
    ],
  },
  {
    continent: "EUROPE",
    regions: [
      {
        name: "WESTERN EUROPE",
        countries: [
          "AUSTRIA",
          "BELGIUM",
          "FRANCE",
          "GERMANY",
          "HUNGARY",
          "LUXEMBOURG",
          "NETHERLANDS",
          "SWITZERLAND",
        ],
      },
      {
        name: "NORTHERN EUROPE",
        countries: [
          "DENMARK",
          "FINLAND",
          "IRELAND",
          "NORWAY",
          "SWEDEN",
          "UNITED KINGDOM",
        ],
      },
      {
        name: "SOUTHERN EUROPE",
        countries: [
          "GREECE",
          "ITALY",
          "PORTUGAL",
          "SPAIN",
          "UNION OF SERBIA AND MONTENEGRO",
        ],
      },
    ],
  },
  {
    continent: "AUSTRALASIA/PACIFIC",
    countries: [
      "AUSTRALIA",
      "FIJI",
      "GUAM",
      "MICRONESIA",
      "NAURU",
      "NEW ZEALAND",
      "PAPUA NEW GUINEA",
    ],
  },
  {
    continent: "AFRICA",
    countries: ["CONGO", "JAMAICA", "KENYA", "NIGERIA", "SOUTH AFRICA"],
  },
];

export default country;
